import { render } from "./OHU.vue?vue&type=template&id=d84722ba&scoped=true"
import script from "./OHU.vue?vue&type=script&lang=js"
export * from "./OHU.vue?vue&type=script&lang=js"

import "./OHU.vue?vue&type=style&index=0&id=d84722ba&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d84722ba"]])

export default __exports__